import { Badge } from "@/components/ui/badge";
import type { OrderStatus } from "@/types";

/**
 * Os rótulos são os mesmos que o cliente vê na linha do tempo do pedido dele.
 * Inventar um vocabulário próprio no painel obrigaria a traduzir mentalmente
 * toda vez que alguém abrisse o aplicativo ao lado.
 */
export const ORDER_STATUS_LABEL: Record<OrderStatus, string> = {
  pending: "Pendente",
  weighing: "Em pesagem",
  confirmed: "Confirmado",
  preparing: "Em preparo",
  ready: "Pronto",
  delivering: "Saiu para entrega",
  delivered: "Entregue",
  cancelled: "Cancelado",
};

const VARIANT: Record<OrderStatus, "default" | "muted" | "ok" | "warning" | "error"> = {
  pending: "warning",
  weighing: "warning",
  confirmed: "default",
  preparing: "default",
  ready: "default",
  delivering: "default",
  delivered: "ok",
  cancelled: "error",
};

export function OrderStatusBadge({ status }: { status: OrderStatus | undefined }) {
  const key = (status ?? "pending") as OrderStatus;
  return <Badge variant={VARIANT[key] ?? "muted"}>{ORDER_STATUS_LABEL[key] ?? key}</Badge>;
}
